module.exports = __webpack_public_path__ + "static/media/dubu-header-logo.011f818e.png";